import './styles/globals.processed.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { App } from './app';
import { ASCII_BANNER } from './ascii-banner';

console.log(ASCII_BANNER);

const elem = document.getElementById('root')!;

const app = (
	<StrictMode>
		<App />
		<Analytics />
		<SpeedInsights />
	</StrictMode>
);

if (import.meta.hot) {
	const root = (import.meta.hot.data.root ??= createRoot(elem));
	root.render(app);
} else {
	createRoot(elem).render(app);
}
